import { render, staticRenderFns } from "./uploadTool.vue?vue&type=template&id=2511b650&scoped=true&"
import script from "./uploadTool.vue?vue&type=script&lang=js&"
export * from "./uploadTool.vue?vue&type=script&lang=js&"
import style0 from "./uploadTool.vue?vue&type=style&index=0&id=2511b650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2511b650",
  null
  
)

export default component.exports